import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import NoshowList from './NoshowList'

export default {
    list: NoshowList,
    icon: PeopleOutlineIcon,
};
